import { render, staticRenderFns } from "./AchievementSquare.vue?vue&type=template&id=6c1a6bfa&scoped=true"
import script from "./AchievementSquare.vue?vue&type=script&lang=js"
export * from "./AchievementSquare.vue?vue&type=script&lang=js"
import style0 from "./AchievementSquare.vue?vue&type=style&index=0&id=6c1a6bfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1a6bfa",
  null
  
)

export default component.exports